let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1epse"), load("joJy8"), load("aHE9G"), load("5joXW")]).then(() => parcelRequire('eJ6HU'));